<template>
    <div>
        <DialogoBlockTramite ref="dialogo" :type="'familiares'"></DialogoBlockTramite>
        <v-card flat class="ma-8">
            <v-card-title class="d-flex justify-space-between align-center">
                <div class="font-weight-bold text-h5 primary--text">{{ titulo }}</div>
                <v-spacer></v-spacer>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn @click.stop="abrirDialogoEditar" v-bind="attrs" v-on="on" :loading="loading"
                            color="primary lighten-1" fab small class="elevation-0" rounded>
                            <v-icon>mdi-pencil-outline</v-icon>
                        </v-btn>
                    </template>
                    <span>Editar familiares</span>
                </v-tooltip>
                <!--             <v-btn class="pa-5 elevation-0" :loading="loading" @click="refresh" color="primary">
                <v-icon class="mr-2">mdi-refresh</v-icon>actualizar
            </v-btn> -->
            </v-card-title>
            <v-card outlined class="rounded-xl mb-6" v-for="item in familiarOrdenado" :key="item.nrodoc">
                <v-card-title class="d-flex justify-space-between align-start font-weight-bold text-body-1 black--text"
                    style="word-break: keep-all;">
                    {{ item.nombres }} {{ item.apellido }}
                </v-card-title>
                <v-card-text>
                    <div class="font-weight-regular black--text"> <strong>
                            Parentesco:
                        </strong>
                        {{ item.destipfamiliar }}
                    </div>
                    <div v-if="item.destipfamiliar !== 'PADRE' && item.destipfamiliar !== 'MADRE'">
                        <div class="font-weight-regular black--text"><strong>
                                DNI:
                            </strong>
                            {{ item.nrodoc }}</div>
                        <div class="font-weight-regular black--text"><strong>
                                Fecha de Nacimiento:
                            </strong>
                            {{ formatDate(item.fecnacim) }}</div>
                    </div>
                </v-card-text>
            </v-card>
        </v-card>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import DialogoBlockTramite from '@/components/dialogos/DialogoBlockTramite.vue';

export default {
    name: 'ListadoFamiliares',
    components: {
        DialogoBlockTramite,
    },
    computed: {
        ...mapGetters(['familiar']),

        titulo() {
            return "Datos de familiares";
        },
        familiarOrdenado() {
            return this.familiar.slice().sort((a, b) => {
                if (a.destipfamiliar < b.destipfamiliar) return -1;
                if (a.destipfamiliar > b.destipfamiliar) return 1;
                return 0;
            });
        }

    },
    data() {
        return {
            loading: false,
            headers: [
                { text: 'PARENTESCO', value: 'destipfamiliar', align: 'center', sortable: false, class: 'primary--text  font-weight-bold' },
                { text: 'NOMBRE Y APELLIDO', value: 'nombres', align: 'center', sortable: false, class: 'primary--text  font-weight-bold' },
                { text: 'DNI', value: 'nrodoc', align: 'center', sortable: false, class: 'primary--text  font-weight-bold' },
                { text: 'FECHA DE NACIMIENTO', value: 'fecnacim', align: 'center', sortable: false, class: 'primary--text  font-weight-bold' },
            ]
        };
    },
    methods: {
        ...mapActions(['getFamiliar']),
        formatDate(date) {
            if (!date) return null
            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        refresh() {
            this.loading = true;
            this.getFamiliar().finally(() => {
                this.loading = false;
            });
        },
        abrirDialogoEditar() {
            this.$refs.dialogo.abrirDialogo()
        }

    },
};
</script>

<style scoped>
.v-data-table {
    margin-top: 20px;
}
</style>
